const TRACEID_RENDER_FRAME = 'RenderFrame';
const TRACEID_RENDER_FRAME_TIME = 'RenderFrameTime';
const TRACEID_RENDER_PASS = 'RenderPass';
const TRACEID_RENDER_PASS_DETAIL = 'RenderPassDetail';
const TRACEID_RENDER_ACTION = 'RenderAction';
const TRACEID_RENDER_TARGET_ALLOC = 'RenderTargetAlloc';
const TRACEID_TEXTURE_ALLOC = 'TextureAlloc';
const TRACEID_SHADER_ALLOC = 'ShaderAlloc';
const TRACEID_SHADER_COMPILE = 'ShaderCompile';
const TRACEID_VRAM_TEXTURE = 'VRAM.Texture';
const TRACEID_VRAM_VB = 'VRAM.Vb';
const TRACEID_VRAM_IB = 'VRAM.Ib';
const TRACEID_VRAM_SB = 'VRAM.Sb';
const TRACEID_BINDGROUP_ALLOC = 'BindGroupAlloc';
const TRACEID_BINDGROUPFORMAT_ALLOC = 'BindGroupFormatAlloc';
const TRACEID_RENDERPIPELINE_ALLOC = 'RenderPipelineAlloc';
const TRACEID_COMPUTEPIPELINE_ALLOC = 'ComputePipelineAlloc';
const TRACEID_PIPELINELAYOUT_ALLOC = 'PipelineLayoutAlloc';
const TRACEID_ELEMENT = 'Element';
const TRACEID_TEXTURES = 'Textures';
const TRACEID_RENDER_QUEUE = 'RenderQueue';
const TRACEID_GPU_TIMINGS = 'GpuTimings';

export { TRACEID_BINDGROUPFORMAT_ALLOC, TRACEID_BINDGROUP_ALLOC, TRACEID_COMPUTEPIPELINE_ALLOC, TRACEID_ELEMENT, TRACEID_GPU_TIMINGS, TRACEID_PIPELINELAYOUT_ALLOC, TRACEID_RENDERPIPELINE_ALLOC, TRACEID_RENDER_ACTION, TRACEID_RENDER_FRAME, TRACEID_RENDER_FRAME_TIME, TRACEID_RENDER_PASS, TRACEID_RENDER_PASS_DETAIL, TRACEID_RENDER_QUEUE, TRACEID_RENDER_TARGET_ALLOC, TRACEID_SHADER_ALLOC, TRACEID_SHADER_COMPILE, TRACEID_TEXTURES, TRACEID_TEXTURE_ALLOC, TRACEID_VRAM_IB, TRACEID_VRAM_SB, TRACEID_VRAM_TEXTURE, TRACEID_VRAM_VB };
